import React from "react";
import Icon from "Trackalyze/Icon";
import Typo from "Trackalyze/Typo";

const DialogToolbar = React.forwardRef(({
  symbol,
  title,
  className,
  style,
  children,
  ...rest
}, ref) => {
  const classes = ["ta-is-center ta-margin_bottom-m", className]
    .filter(Boolean)
    .join(" ");

  return (
    <div ref={ref} className="ta-is-center" style={style} {...rest}>
      {symbol && (
        <Icon
          symbol={symbol}
          className="ta-margin_bottom-m ta-color-text_on-surface-variant"
          size="l"
        />
      )}

      <Typo type="headline" size="s" className={classes}>
        {title}
        {children}
      </Typo>
    </div>
  );
});

export default DialogToolbar;
